module.exports = require("./stream/stream")


//////////////////
// WEBPACK FOOTER
// ./~/mithril/stream.js
// module id = 321
// module chunks = 0